import { Component, Inject, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from "@ngx-translate/core";
import { CommonService } from '../../services/common.service';
import { CommonModule } from '@angular/common';
import { AuthGuardService } from '../../guard/auth-guard/auth-guard.service';
import { Router } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-locale-switcher',
  standalone: true,
  imports: [FormsModule, MatFormFieldModule, MatSelectModule, CommonModule],
  templateUrl: './locale-switcher.component.html',
  styleUrl: './locale-switcher.component.scss'
})
export class LocaleSwitcherComponent {
  // languageList = [
  //   { code: 'en', label: 'English' },
  //   { code: 'fr', label: 'French' },
  //   { code: 'de', label: 'German' },
  //   { code: 'es', label: 'Spanish' },
  //   { code: 'th', label: 'Thai' },
  // ];
  languageList: any = [];
  siteLanguage: any;
  currentLanguage: any;
  affilateList: any =[];
  selectedaffiliateName: any;
  role: any;

  constructor(@Inject(LOCALE_ID) public activeLocale: string, private translate: TranslateService, public _service: CommonService, public authGuardSrvc: AuthGuardService, public router: Router,public _utilService:UtilService, private readonly authService: AuthService) {
    this._service.selectedAffilate = localStorage.getItem('Affiliate');
    this.translate.addLangs(['en', 'fr', 'de', 'th', 'es','ja','pt','id']);
    this.translate.setDefaultLang('en');
    // SECURITY: derive from the verified in-memory id token, not the client-writable
    // localStorage 'roles' array (AppSec finding: role derived from client-modifiable storage).
    const roles: string[] = this.authService.getRolesFromIdToken();
    if (roles.length > 0 && roles.some((r: string) => r.includes('Admin') || r.includes('Oversight'))) {
      this.role = 'Admin'
    } else {
      this.role = this.authGuardSrvc.getRole();
    }
    // this.role = this.authGuardSrvc.getRole();
    this.siteLanguage = localStorage.getItem("langCode")!;
    this.translate.use(localStorage.getItem("langCode")!);
    this.getAffiliates();
    // this.getaffiliateLanguage();
  }

  getaffiliateLanguage() {
    this._service.getaffiliateLanguage().subscribe((res: any) => {
      if (res.payload[0] !== null) {
        const data = res.payload
        this.languageList = data.map((item: any) => ({
          code: item.language_code,
          label: this.toCamelCase(item.language_name)
        }));
       this.currentLanguage = (this.languageList?.find((el:any) => el.code === this.siteLanguage) || {})?.label
      }
    },err=>{
      this._utilService.openSnackBar('Unable to get languages')
    })
  }

  // Language dropdown selection change
  changeSiteLanguage(localeCode: string): void {
    this.siteLanguage = localeCode;
    this.translate.use(localeCode);
    localStorage.setItem("langCode", localeCode);
    this._service.langCode = localeCode
    localStorage.setItem('langCode', this._service.langCode);
    window.location.reload()
  }

  // To get Affiliate dropdown options list
  getAffiliates() {
    this._service.getAffiliatesList().subscribe((res: any) => {
      if (res.payload[0] !== null) {
        this.affilateList = res.payload;
        const af = this.authGuardSrvc.getAffliate();
        af.includes(this._service.selectedAffilate)
        if (!af.includes(this._service.selectedAffilate)) {
          af.push(this._service.selectedAffilate)
        }
        this.affilateList = this.affilateList.filter((item: any) => af.includes(item.affiliate_code));
        this.selectedaffiliateName = this.affilateList.find((item: any) => item.affiliate_code === this._service.selectedAffilate);
        this.getaffiliateLanguage();

      }
    },err=>{
      this._utilService.openSnackBar('Unable to get affiliates')
    })
  }


  // Affiliate dropdown selection change to set affiliate value
  affiliatchng() {
    localStorage.setItem('Affiliate', this._service.selectedAffilate);
    const selectedAffiliate = this.affilateList.find((item: any) => item.affiliate_code === this._service.selectedAffilate);
    localStorage.setItem('hrsystem', String(selectedAffiliate?.hr_system_enabled ?? false));
    localStorage.removeItem('filtersts');
    localStorage.removeItem('approvalTab')
    localStorage.removeItem('historicStatus');
    const url = this.router.url;
    if (url === '/home') {
      window.location.reload();
    } else {
      this.router.navigate(['/home'])
        .then(() => {
          window.location.reload();
        });
    }
  }

  toCamelCase(str: string): string {
    if (!str) { return '' };
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

}
